import * as Scrivito from "scrivito";
import React from "react";
import { Select } from "components";
import { useProjectListContext } from "../../hooks/useProjectListContext";

export const DepartmentDropdown = Scrivito.connect(() => {
  const { selectedDepartment, setSelectedDepartment, departmentOptions } =
    useProjectListContext();

  const handleSelectDepartment = (dept) => {
    if (dept.value !== selectedDepartment.value) {
      setSelectedDepartment(dept);
      Scrivito.navigateTo(() => Scrivito.currentPage(), {
        params: { page: "1" },
      });
    }
  };

  return (
    <div className="col-3">
      <div className="d-flex text-gray-700 fw-bold">Department</div>
      <Select
        onChange={handleSelectDepartment}
        options={departmentOptions}
        value={selectedDepartment}
        name="departmentSelect"
        testId="department-select"
      />
    </div>
  );
});
